import { render } from "./ProtocoloComponent.vue?vue&type=template&id=13d814f8&scoped=true"
import script from "./ProtocoloComponent.vue?vue&type=script&lang=js"
export * from "./ProtocoloComponent.vue?vue&type=script&lang=js"

import "./ProtocoloComponent.vue?vue&type=style&index=0&id=13d814f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d814f8"]])

export default __exports__